<div class="table-container">
  <mat-spinner class="loader" *ngIf="!tableData"></mat-spinner>
  <div *ngIf="displayedColumns">
    <div [ngStyle]="{ display: showGrid() }">
      <table
        #table
        mat-table
        appMatTableResponsive
        [dataSource]="tableData.results"
        *ngIf="columnIdList.length"
      >
        <tr mat-header-row *matHeaderRowDef="columnIdList"></tr>
        <tr mat-row *matRowDef="let row; columns: columnIdList"></tr>
        <ng-container
          *ngFor="
            let col of displayedColumns;
            trackBy: 'columnIndex' | trackByKey
          "
          [matColumnDef]="col.columnId"
        >
          <th mat-header-cell *matHeaderCellDef>
            {{ col.columnName | uppercase }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="cell-text">
              <span [ngStyle]="getStyleByCol(col, row[col.columnId])">{{
                row[col.columnId]
              }}</span>
            </div>
          </td>
        </ng-container>
        <ng-container
          *ngIf="tableConfig?.actionList.length"
          matColumnDef="actions"
        >
          <th mat-header-cell *matHeaderCellDef id="action-header">
            {{ 'Actions' | uppercase }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="action-container">
              <ng-container
                *ngFor="
                  let action of tableConfig.actionList;
                  trackBy: 'order' | trackByKey
                "
              >
                <ng-container *ngIf="action.path || action.action">
                  <button
                    type="button"
                    [matTooltip]="action.label"
                    mat-button
                    [routerLink]="joinPaths(action.path, row.id, action.action)"
                  >
                    <mat-icon
                      color="primary"
                      fontSet="material-icons-outlined"
                      [attr.aria-label]="action.label"
                      aria-hidden="false"
                      >{{ action.icon }}
                    </mat-icon>
                    <span class="cdk-visually-hidden">{{ action.label }}</span>
                  </button>
                </ng-container>
                <ng-container *ngIf="action.event">
                  <button
                    type="button"
                    [matTooltip]="action.label"
                    mat-button
                    (click)="emit(row, action.event)"
                  >
                    <mat-icon
                      color="primary"
                      fontSet="material-icons-outlined"
                      [attr.aria-label]="action.label"
                      aria-hidden="false"
                      >{{ action.icon }}
                    </mat-icon>
                    <span class="cdk-visually-hidden">{{ action.label }}</span>
                  </button>
                </ng-container>
              </ng-container>
            </div>
          </td>
        </ng-container>
      </table>
      <mat-paginator
        [length]="tableData.total"
        [pageSizeOptions]="[10, 50, 100]"
        [pageIndex]="tableData?.options?.page"
        (page)="pageUpdate($event)"
        showFirstLastButtons
        aria-label="Select page of periodic elements"
      ></mat-paginator>
    </div>
    <div class="center" *ngIf="!tableData.results.length">
      {{ tableConfig?.emptyListMessage }}
    </div>
  </div>
</div>
